import { render, staticRenderFns } from "./StatisticsStudent.vue?vue&type=template&id=7369205a&scoped=true&"
import script from "./StatisticsStudent.vue?vue&type=script&lang=js&"
export * from "./StatisticsStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7369205a",
  null
  
)

export default component.exports